import { createSlice } from "@reduxjs/toolkit";

export type Media = {
  id: number;
  name: string;
  size: number;
  mime_type: string;
  collection_name: string;
  custom_properties: {
    [name: string]: string;
  };
  created_at: string;
  updated_at: string;
};

type InitialState = {
  data: Media[];
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  isLoading: false,
};

const documentSlice = createSlice({
  name: "documentSlice",
  initialState,
  reducers: {
    request: (state, action) => {
      state.isLoading = true;
    },
    upload: (state, action) => {
      state.isLoading = true;
    },
    delete: (state, action) => {
      state.isLoading = true;
    },
    download: (state, action) => {
      state.isLoading = true;
    },
    addData: (state, action) => {
      state.data = [...state.data, ...action.payload];
    },
    removeData: (state, action) => {
      const id = action.payload;

      state.data = state.data.filter(
        (document) => document.id.toString() !== id.toString()
      );
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default documentSlice;
